// API images look like { imageUrl, imageVariants: [{ url, width }] }.
// imageUrl is the 768px "tablet" copy and stays the fallback for images uploaded
// before the fixed-width variants existed (their imageVariants is empty).

// <img> props: the browser picks the variant that fits the rendered size × pixel density
export const imageSrcProps = (image, sizes = '100vw') => {
  const variants = image?.imageVariants || [];
  if (!variants.length) {
    return { src: image?.imageUrl };
  }

  return {
    src: image.imageUrl,
    srcSet: variants.map((variant) => `${variant.url} ${variant.width}w`).join(', '),
    sizes,
  };
};

// single URL for places that can't take a srcSet (CSS backgrounds, MUI CardMedia):
// the smallest variant covering cssWidth on this screen, else the biggest one
export const pickImageUrl = (image, cssWidth, pixelRatio = window.devicePixelRatio || 1) => {
  const variants = [...(image?.imageVariants || [])].sort((a, b) => a.width - b.width);
  if (!variants.length) {
    return image?.imageUrl;
  }

  const needed = cssWidth * pixelRatio;
  const fit = variants.find((variant) => variant.width >= needed) || variants[variants.length - 1];
  return fit.url;
};
